/**
 * @param a {string}
 * @param b {string}
 *
 * @returns {number}
 */
export default function(a, b) {
    const aValue = String(a);
    const bValue = String(b);

    return aValue.localeCompare(bValue);
}
